import _ from 'underscore';

export function convertBingMapsResponseToOdata(bingMapsResponse) {
  const resourceSet = _.first(bingMapsResponse && bingMapsResponse.resourceSets);
  const { resources, estimatedTotal } = resourceSet || {};

  const value = resources && _.map(resources, (r) => {
    let CountryCode;
    const ParentLocations = [];

    if (r.address) {
      CountryCode = r.address.countryRegionIso2;

      // check for state field
      if (r.address.adminDistrict) {
        ParentLocations.push({
          ExpandedName: r.address.adminDistrict,
          Type: 'SubGeography',
          CountryCode,
        });
      }

      // check for city field
      if (r.address.locality) {
        ParentLocations.push({
          ExpandedName: r.address.locality,
          Type: 'City',
          CountryCode,
        });
      }
    }

    return {
      ExpandedName: r.name,
      Type: r.entityType,
      GeoPoint: {
        Latitude: r.point.coordinates[0],
        Longitude: r.point.coordinates[1],
      },
      CountryCode,
      ParentLocations,
    };
  });

  return {
    '@odata.count': estimatedTotal || 0,
    value,
  };
}
